/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminDocumentControllerCreate } from '../fn/admin-document/admin-document-controller-create';
import { AdminDocumentControllerCreate$Params } from '../fn/admin-document/admin-document-controller-create';
import { adminDocumentControllerDelete } from '../fn/admin-document/admin-document-controller-delete';
import { AdminDocumentControllerDelete$Params } from '../fn/admin-document/admin-document-controller-delete';
import { adminDocumentControllerFindAll } from '../fn/admin-document/admin-document-controller-find-all';
import { AdminDocumentControllerFindAll$Params } from '../fn/admin-document/admin-document-controller-find-all';
import { adminDocumentControllerFindById } from '../fn/admin-document/admin-document-controller-find-by-id';
import { AdminDocumentControllerFindById$Params } from '../fn/admin-document/admin-document-controller-find-by-id';
import { adminDocumentControllerSearchCursor } from '../fn/admin-document/admin-document-controller-search-cursor';
import { AdminDocumentControllerSearchCursor$Params } from '../fn/admin-document/admin-document-controller-search-cursor';
import { adminDocumentControllerSearchOffset } from '../fn/admin-document/admin-document-controller-search-offset';
import { AdminDocumentControllerSearchOffset$Params } from '../fn/admin-document/admin-document-controller-search-offset';
import { adminDocumentControllerUpdate } from '../fn/admin-document/admin-document-controller-update';
import { AdminDocumentControllerUpdate$Params } from '../fn/admin-document/admin-document-controller-update';
import { AdminDocumentDto } from '../models/admin-document-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class AdminDocumentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminDocumentControllerFindAll()` */
  static readonly AdminDocumentControllerFindAllPath = '/api/adminDocument';

  /**
   * 문서 전체 조회.
   *
   * 문서 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerFindAll$Response(params?: AdminDocumentControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AdminDocumentDto>>> {
    return adminDocumentControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 전체 조회.
   *
   * 문서 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerFindAll(params?: AdminDocumentControllerFindAll$Params, context?: HttpContext): Observable<Array<AdminDocumentDto>> {
    return this.adminDocumentControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AdminDocumentDto>>): Array<AdminDocumentDto> => r.body)
    );
  }

  /** Path part for operation `adminDocumentControllerCreate()` */
  static readonly AdminDocumentControllerCreatePath = '/api/adminDocument';

  /**
   * 관리자 - 입점사 문서 생성.
   *
   * 관리자 - 입점사 문서를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentControllerCreate$Response(params: AdminDocumentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDocumentDto>> {
    return adminDocumentControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 - 입점사 문서 생성.
   *
   * 관리자 - 입점사 문서를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentControllerCreate(params: AdminDocumentControllerCreate$Params, context?: HttpContext): Observable<AdminDocumentDto> {
    return this.adminDocumentControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDocumentDto>): AdminDocumentDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentControllerSearchOffset()` */
  static readonly AdminDocumentControllerSearchOffsetPath = '/api/adminDocument/search/offset';

  /**
   * 문서 오프셋 기반 조회.
   *
   * 문서를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerSearchOffset$Response(params: AdminDocumentControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return adminDocumentControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 오프셋 기반 조회.
   *
   * 문서를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerSearchOffset(params: AdminDocumentControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.adminDocumentControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentControllerSearchCursor()` */
  static readonly AdminDocumentControllerSearchCursorPath = '/api/adminDocument/search/cursor';

  /**
   * 문서 커서 기반 조회.
   *
   * 문서를 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerSearchCursor$Response(params: AdminDocumentControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return adminDocumentControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 커서 기반 조회.
   *
   * 문서를 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerSearchCursor(params: AdminDocumentControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.adminDocumentControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentControllerFindById()` */
  static readonly AdminDocumentControllerFindByIdPath = '/api/adminDocument/{id}';

  /**
   * 문서 ID 기반 조회.
   *
   * 문서를 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerFindById$Response(params: AdminDocumentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDocumentDto>> {
    return adminDocumentControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 ID 기반 조회.
   *
   * 문서를 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerFindById(params: AdminDocumentControllerFindById$Params, context?: HttpContext): Observable<AdminDocumentDto> {
    return this.adminDocumentControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDocumentDto>): AdminDocumentDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentControllerDelete()` */
  static readonly AdminDocumentControllerDeletePath = '/api/adminDocument/{id}';

  /**
   * 문서 삭제.
   *
   * 문서를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerDelete$Response(params: AdminDocumentControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDocumentDto>> {
    return adminDocumentControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 삭제.
   *
   * 문서를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerDelete(params: AdminDocumentControllerDelete$Params, context?: HttpContext): Observable<AdminDocumentDto> {
    return this.adminDocumentControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDocumentDto>): AdminDocumentDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentControllerUpdate()` */
  static readonly AdminDocumentControllerUpdatePath = '/api/adminDocument/{id}';

  /**
   * 문서 수정.
   *
   * 문서를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentControllerUpdate$Response(params: AdminDocumentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDocumentDto>> {
    return adminDocumentControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 수정.
   *
   * 문서를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentControllerUpdate(params: AdminDocumentControllerUpdate$Params, context?: HttpContext): Observable<AdminDocumentDto> {
    return this.adminDocumentControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDocumentDto>): AdminDocumentDto => r.body)
    );
  }

}
